exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row; }\n  :host nav {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex; }\n  :host nav.user-nav {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n        -ms-flex-direction: row-reverse;\n            flex-direction: row-reverse; }\n  :host figure {\n    padding: 18px;\n    margin: 0; }\n  :host a {\n    padding: 0 20px;\n    line-height: 64px;\n    opacity: .4; }\n  :host a.active {\n    opacity: 1;\n    border-bottom: 2px red solid; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/shared/top-navigation/top-navigation.component.scss
// module id = ../../../../../src/app/pages/shared/top-navigation/top-navigation.component.scss
// module chunks = main